import { createSelector } from "reselect";

export const selectWorkItems = state => state.worklistFilterReducer.workitems;

export const selectWorkItemById = id => {
  return createSelector(selectWorkItems, items =>
    items.find(x => x.workItemId === id)
  );
};

export const selectWorkListFilters = state =>
  state.worklistFilterReducer.filters;

export const selectStateFilterInput = state =>
  state.worklistFilterReducer.inputs.state;
export const selectTextFilterInput = state =>
  state.worklistFilterReducer.inputs.text;

export const selectWorkStatus = state =>
  state.worklistFilterReducer.filters.status;

export const selectWorklistItems = createSelector(selectWorkItems, items =>
  items.map(item => ({
    id: item.workItemId,
    ...item.attributes
  }))
);

export const selectIsLoading = state => state.worklistFilterReducer.loading;

export const selectError = state => state.worklistFilterReducer.error;
